import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { Skeleton } from '@mui/material';
import { ListItem } from './eventCheckoutHeaderV1';
import { EventInfoItem } from '../eventInfoItem';
import { CheckoutType } from '../../../store/checkout/types';
import { useCheckoutHelper } from '../../../helpers/customHooks';
import { useUtils } from '../../../services/useUtils';
import { PriceInfoLoaderWrapper, PriceInfoLoaderOverlay } from './priceInfoStyles';

export const PriceInfo: FC<PriceInfoPropsType> = memo(({ checkout, isAuthorized, totalPrice, isInitiateLoading }) => {
  const { t } = useTranslation();

  const { isInitiated } = useCheckoutHelper();
  const { getEmojiFlagByCurrency, round } = useUtils();

  if (!isInitiated(checkout)) {
    return null;
  }

  const { initiate, process } = checkout;

  if (isEmpty(initiate.paymentMethods)) {
    return null;
  }

  const { currency } = checkout.initiate.event;

  const pricePayByPoints = process ? round(process?.pricePayByPoints) : round(initiate?.pricePayByPoints);
  const pricePayByPointsFormatted = `${pricePayByPoints} ${t('Checkout.PointsCurrency')} ${getEmojiFlagByCurrency(currency)}`;
  const pricePayByCard = process ? round(process?.pricePayByCard) : round(initiate?.pricePayByCard);

  let title = checkout?.process?.priceTotal
    ? `${checkout.process.priceTotal} ${currency}`
    : `${totalPrice} ${currency}`;

  let subtitle = 'All fees included';

  if (checkout.usePoints) {
    title = t('Checkout.PayAmountByCard', {
      amount: pricePayByCard,
      currency,
      defaultValue: `Pay ${pricePayByCard} ${currency} by card`,
    });
    subtitle = t('Checkout.PointsCoverRest', {
      points: pricePayByPointsFormatted,
      defaultValue: `Points covers the rest`,
    });
  }

  if (isInitiateLoading === true) {
    return (
      <ListItem>
        <PriceInfoLoaderWrapper>
          <EventInfoItem icon="purse" themed title=" " subtitle=" " />
          <PriceInfoLoaderOverlay>
            <Skeleton animation="wave" variant="text" width="80%" height={20} sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
            <Skeleton animation="wave" variant="text" width="50%" height={16} sx={{ bgcolor: 'rgba(255,255,255,0.15)' }} />
          </PriceInfoLoaderOverlay>
        </PriceInfoLoaderWrapper>
      </ListItem>
    );
  }

  return (
    <ListItem>
      <EventInfoItem icon="purse" themed title={title} subtitle={subtitle} />
    </ListItem>
  );
});

type PriceInfoPropsType = {
  checkout: CheckoutType;
  isAuthorized: boolean;
  totalPrice: number;
  isInitiateLoading?: boolean;
};
